import type { ConversationMessage } from '../../types/conversation-message';
import { CheckmarkCircleFillSFSymbolRegular } from '@/assets/sf-symbols/regular/checkmark.circle.fill';
import { DiffFileTree } from './diff-file-tree';

export const SandboxReviewMessage = ({
  message,
}: {
  message: ConversationMessage;
}) => {
  const reviewDiff = message.reviewDiff ?? [];
  const reviewDiffTotal = message.reviewDiffTotal ?? reviewDiff.length;
  const hiddenCount = Math.max(0, reviewDiffTotal - reviewDiff.length);

  return (
    <div className="select-none rounded-xl overflow-hidden border border-border bg-surface-card">
      <div className="flex items-center px-2 py-1.5 gap-1">
        <div className="flex-shrink-0 w-5 h-5 flex items-center justify-center">
          <CheckmarkCircleFillSFSymbolRegular className="text-[#25D083] text-[0.9375rem]" />
        </div>
        <span className="text-[0.8125rem] text-text-primary font-medium leading-tight">
          {message.acceptedSummary ?? 'Workspace changes reviewed.'}
        </span>
      </div>

      {reviewDiff.length > 0 && (
        <div className="px-2 pb-2">
          <DiffFileTree diffs={reviewDiff} readOnly maxHeight={240} />
        </div>
      )}

      {hiddenCount > 0 && (
        <div className="px-2 pb-2 text-xs leading-4 text-text-secondary">
          Showing first {reviewDiff.length} of {reviewDiffTotal} changes.{' '}
          {hiddenCount} hidden.
        </div>
      )}
    </div>
  );
};
